//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            02nd October 2018
//  * @type            Center Questions Component File
//  * @description -   This file renders the html and functionality for center component when questions tab is choosed.
<template>
  <div class="col-md-6 p-0 col-xs-12 survey_colume_2">
    <v-wait for="creating question">
      <template slot="waiting">
        <!-- <div id="designLoadingdiv">
          <img class="designAjaxLoader" src="../../assets/images/loader.gif" />
        </div> -->
        <div id="loadingDiv" class="loadingDiv_analytics">
            <div class="loadersec">
              <div class="loader"></div>
            </div>
        </div>
      </template>
    </v-wait>
    <div v-bar="{scrollThrottle: 30, draggerThrottle: 30, preventParentScroll: true}">
      <div class="colume_2_question padding15 sticky_bar">
        <div class="top_setting_bar">
          <div class="d_center">
            <!-- <a
              v-if="all.in_survey_type == 3"
              href="#"
              class="iconDisplayCustom"
              data-toggle="tooltip"
              data-placement="top"
              title="Both"
            >
              <i class="fa fa-globe"></i>
              <i class="fa fa-1x fa-mobile iconClassBtn"></i>
            </a>-->
            <a
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              title="Online Form"
              :class="all.in_survey_type == 1 || all.in_survey_type == 3 ? '' : 'disabled-icon'"
            >
              <i class="fa fa-globe" aria-hidden="true"></i>
            </a>
            <a
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              title="Mobile Form"
              :class="all.in_survey_type == 2 || all.in_survey_type == 3 ? '' : 'disabled-icon'"
            >
              <i class="fa fa-mobile icon-mobile-fn-size" aria-hidden="true"></i>
            </a>
            <a
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              title="Kisok Form"
              :class="all.in_survey_type == 4 ? '' : 'disabled-icon'"
            >
              <i class="fa fa-desktop icon-desktop-fn-size" aria-hidden="true"></i>
            </a>
            <a
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              :class="all.in_survey_type == 4 ? 'disabled-icon':''"
              :title="all.in_question_flow == 0 ? 'One At A Time' : 'All In One'"
            >
              <i
                :class="all.in_question_flow == 0 ? 'fa fa-long-arrow-down' : 'fa fa-sort-alpha-asc'"
                aria-hidden="true"
              ></i>
            </a>

            <a
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              title="Audit For"
              :class="all.in_audit ? '' : 'disabled-icon'"
            >
              <!--<img src="../../assets/images/edit-icon-1.png" alt="edit-icon" class="img-responsive">-->
              <i class="fa fa-tachometer"></i>
            </a>
            <a
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              title="Loop For"
              :class="all.in_loop_survey ||  all.in_survey_type == 4 ? '' : 'disabled-icon'"
            >
              <i class="fa fa-refresh" aria-hidden="true"></i>
            </a>
          </div>
          <div class="arrow_tab">
            <a
              :class="{'disabled': !isExpandEnabled, 'chevron-down-bg-color': isExpand}"
              href="#"
              data-toggle="tooltip"
              data-placement="top"
              title="Expand/Collapse"
              v-on:click="isExpandEnabled ? (isExpand=!isExpand , isExpand ? expandAll() : collapseAll()):''"
            >
              <i :class="isExpand ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" aria-hidden="true"></i>
            </a>
          </div>
        </div>
        <!-- Start screen code -->
        <div
          v-if="questionStartEnd.start && startActivate === 1"
          class="row"
          @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : questionChanged($event, -2)"
        >
          <div
            :class="currentQuestion == -2 ? 'question_colume mtop25 selectedQuestion' : 'question_colume mtop25'"
            :data-que-id="questionStartEnd['start']['in_question_master_id']"
            :data-que-type-id="questionStartEnd['start']['in_question_type_id']"
            :data-id="questionStartEnd['start']['question_type_details'] ? questionStartEnd['start']['question_type_details']['in_control_id'] : ''"
            :data-controlName="'Start screen'"
            :data-className="'fa fa-play-circle-o'"
          >
            <div class="panel-group" id="accordion">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <span
                    :class="questionLists.length > 99 ? 'width40px' : 'width30px'"
                    v-if="questionLists.length > 0"
                  >0</span>
                  <h4 class="panel-title">
                    <i class="fa fa-play-circle-o activeStartEndScreen" aria-hidden="true"></i>
                    <a
                      href="#"
                      data-toggle="collapse"
                      class="collapse-new"
                      data-parent="#accordion"
                    >
                      Start Screen
                      <i
                        id="startExpandCollapse"
                        :class="startCollapsed ? 'accordion-toggle collapsed' : 'accordion-toggle'"
                        v-on:click.prevent="startCollapsed = !startCollapsed"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <ul class="nav question_option">
                      <li>
                        <a
                          href="#"
                          @click.prevent
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Activate/Deactivate Start Screen"
                        >
                          <i
                            :data-que-id="questionStartEnd['start']['in_question_master_id']"
                            :data-que-type-id="questionStartEnd['start']['in_question_type_id']"
                            :data-id="questionStartEnd['start']['question_type_details'] ? questionStartEnd['start']['question_type_details']['in_control_id']:''"
                            :data-controlName="'Start screen'"
                            class="startActivateIcon fa fa-trash-o"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </h4>
                </div>

                <div
                  v-if="!startCollapsed"
                  :class="currentQuestion == -2 ? 'panel-collapse collapse in show' :'panel-collapse collapse in show'"
                >
                  <expanddisplay :qid="questionStartEnd['start']['in_question_master_id']"></expanddisplay>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if=" startActivate === 0 && (endActivate === 1 || questionLists.length > 0)"
          class="row"
        >
          <div class="question_colume mtop25">
            <div class="panel-group" id="accordion">
              <div class="panel panel-default">
                <div
                  class="panel-heading"
                  @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : questionChanged($event, -2)"
                >
                  <h4
                    class="panel-title startActivateIcon deactivated"
                    :data-que-id="questionStartEnd['start']['in_question_master_id']"
                    :data-que-type-id="questionStartEnd['start']['in_question_type_id']"
                    :data-id="questionStartEnd['start']['question_type_details'] ?  questionStartEnd['start']['question_type_details']['in_control_id']:''"
                    :data-controlName="'Start screen'"
                    :data-className="'fa fa-play-circle-o'"
                  >
                    <i class="deactivate fa fa-play-circle-o" aria-hidden="true"></i>
                    <a
                      href="#"
                      class="startActivateIcon"
                      @click.prevent
                      data-toggle="collapse"
                      data-parent="#accordion"
                    >Click to add Start Screen</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="question_colume mtop25" v-if="endActivate === 1 || questionLists.length > 0">
            <div class="panel-group" id="accordion">
              <div
                class="panel panel-default"
                @click.prevent=" questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : (addStartEndScreen(-2))"
              >
                <div class="panel-heading">
                  <h4 class="panel-title startActivateIcon deactivated" @click.prevent>
                    <i class="deactivate fa fa-play-circle-o" aria-hidden="true"></i>
                    <a class="startActivateIcon" href="#" @click.prevent>Click to add Start Screen</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="question_colume"
            :style="questionLists.length == 0 ? '' : 'margin-bottom: 1px;'"
          >
            <div class="panel-group" id="accordion">
              <!-- <h4 v-for="(questionList, index) in questionLists"></h4> -->
              <draggable
                v-model="questionLists"
                :class="questionLists.length == 0 ? 'temp-drag-box dragArea icon-edit dragAreaMessage mtop50' :'dragArea icon-edit'"
                @change="onChange"
                @sort="onSort"
                :move.once="checkMoveOfQuestion"
                :options="dragOptions"
                :style="questionLists.length == 0 ? 'border: 2px dashed #969696;' : ''"
              >
                <!-- <div class="dragImage" v-if="questionLists.length == 0">
                  <img
                    src="../../assets/images/page_build_img.png"
                    alt="blub image"
                    class="img-responsive"
                  />
                </div>-->
                <!-- <div > -->
                <!-- {{setQuestionTitle}} -->
                <emptyquestion
                  ref="collapsible"
                  v-for="(questionList, index) in questionLists"
                  :key="questionList['in_question_master_id'] ? questionList['in_question_master_id'] : questionList['dbQueId']"
                  :cid="questionList['in_control_id'] ? questionList['in_control_id'] : questionList['question_type_details']['in_control_id']"
                  :qid="index+1"
                  :controlName="questionList['st_control_name'] ? questionList['st_control_name'] : questionList['question_type_details']['control_details']['st_control_name']"
                  :dbQid="questionList"
                  :className="questionList['st_class_name'] ? questionList['st_class_name'] : questionList['question_type_details']['control_details']['st_class_name']"
                  :questionName="questionList['st_question_title'] ? questionList['st_question_title'] : questionList['st_control_name'] ? questionList['st_control_name'] +' Question' : 'Image Question'"
                  :questionNo="index+1"
                  :questionNoClass="questionLists.length > 99 ? 'width40px' : 'width30px'"
                  :isRequired="questionList['question_validation_details'] ? (questionList['question_validation_details'][0] ? (questionList['question_validation_details'][0]['question_answer_details'] ? (questionList['question_validation_details'][0]['question_answer_details'][0] ? questionList['question_validation_details'][0]['question_answer_details'][0]['st_answer_text'] : 0) : 0): 0) : 0 "
                  :dbQTypeId="questionList['in_question_type_id']"
                  @click.native=" questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : (questionChanged($event, index))"
                  :isInSkipLogic="questionList['in_question_master_id'] ? mySetAsList.includes(questionList['in_question_master_id']) : mySetAsList.includes(questionList['dbQueId'])"
                  :ansInSkipLogic="questionList['in_question_master_id'] ? skipLogicAnsDetails[questionList['in_question_master_id']] : skipLogicAnsDetails[questionList['dbQueId']]"
                  :class="{selectedQuestion:index == currentQuestion}"
                  :skipLogicEndQues="skipLogicEndQ"
                  :isAuditScoreAvailable="surveyQuestionWithDetails"
                ></emptyquestion>
                <!-- </div> -->
              </draggable>
            </div>
            <div>
              <!-- Modal Component -->
              <b-modal ref="scoreModal" title="Scoring" hide-footer>
                <div slot="modal-title">
                  Scoring
                  <h6
                    v-if="questionLists[modalQindex]"
                  >{{questionLists[modalQindex]['st_question_title']}}</h6>
                </div>
                <div slot="modal-header-close">
                  <button type="button" class="close" @click="closeModal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <!--<div class="modal-title">
                <h3>Scoring</h3>
                <h6>Question title</h6>
                </div>-->
                <div class="modal-body-content score-content-body">
                  <!-- {{surveyQuestionWithDetails[modalQid]}} -->
                  <form
                    @submit.stop.prevent="handleSubmit"
                    v-if="surveyQuestionWithDetails[modalQid] && (surveyQuestionWithDetails[modalQid]['qval_38']|| surveyQuestionWithDetails[modalQid]['qval_6'] ) ? (ansArray = [], ansArray = (surveyQuestionWithDetails[modalQid]['qval_6']) ? surveyQuestionWithDetails[modalQid]['qval_6']['st_answer_text'].split('\n') : parseInt(surveyQuestionWithDetails[modalQid]['qval_38']['st_answer_text'])) : surveyQuestionWithDetails[modalQid] && surveyQuestionWithDetails[modalQid]['qval_39'] ? (ansArray = [], ansArray = smileyAnsVal) : 0"
                  >
                    <h6>Enter a numeric score against each answer.Blank field would not be counted towards total score.</h6>
                    <div style="height: 200px !important;" v-bar="{preventParentScroll: true}">
                      <table class="table">
                        <tbody>
                          <tr v-for="(k,i) in ansArray" :key="i">
                            <td>
                              <label
                                v-if="surveyQuestionWithDetails[modalQid]['qval_6']"
                                class="modal-label"
                              >{{ansArray[i]}}</label>
                              <span
                                v-else-if="surveyQuestionWithDetails[modalQid]['qval_39']"
                                class="modal-label ck-span"
                              >
                                <i :class="smileyClass[ansArray[i]]"></i>
                              </span>
                              <span v-else class="skiplogic rating">
                                <span class="icon" v-for="j in i+1" :key="j">★</span>
                              </span>
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                v-model="ansArrayValues[i]"
                                v-validate="'required|numeric|max_value:1000000'"
                                :name="'score '+i"
                                :key="'score '+i"
                                data-vv-as="above"
                                v-on:keypress="isNumberOnly($event)"
                              />
                              <span
                                class="error"
                                v-if="errors.has('score ' + i)"
                              >{{ errors.first('score ' + i)}}</span>
                            </td>
                            <td>
                              <a
                                v-if="surveyQuestionWithDetails[modalQid]['qval_6'] || surveyQuestionWithDetails[modalQid]['qval_39']"
                                href="#"
                                @click.prevent="duplicateValues(i,ansArray.length)"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Duplicate all of the following answers"
                              >
                                <i id="copyModalValues" class="fa fa-files-o" aria-hidden="true"></i>
                              </a>
                              <a
                                v-else
                                href="#"
                                @click.prevent="duplicateValues(i,ansArray)"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Duplicate all of the following answers"
                              >
                                <i id="copyModalValues" class="fa fa-files-o" aria-hidden="true"></i>
                              </a>
                            </td>
                          </tr>
                          <!-- To display other option in list control -->
                          <tr
                            v-if="surveyQuestionWithDetails[modalQid]['qval_13'] && surveyQuestionWithDetails[modalQid]['qval_13']['st_answer_text']"
                          >
                            <td>
                              <label class="modal-label">Other</label>
                            </td>
                            <td>
                              <input
                                type="number"
                                v-model="scoreOther"
                                v-validate="'required|numeric|max_value:1000000'"
                                :name="'scoreOther'"
                                :key="'scoreOther'"
                                data-vv-as="above"
                                v-on:keypress="isNumberOnly($event)"
                              />
                              <span
                                class="error"
                                v-if="errors.has('scoreOther')"
                              >{{ errors.first('scoreOther')}}</span>
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form>
                  <!-- Form for multiple choice type -->
                  <form
                    @submit.stop.prevent="handleSubmit"
                    v-if="surveyQuestionWithDetails[modalQid] && ( surveyQuestionWithDetails[modalQid]['qval_14'] || surveyQuestionWithDetails[modalQid]['qval_15'] || surveyQuestionWithDetails[modalQid]['qval_16'] || surveyQuestionWithDetails[modalQid]['qval_17'] || surveyQuestionWithDetails[modalQid]['qval_40'] ) ? 1 : 0 "
                    class="marginB10"
                  >
                    <h6>Enter a numeric score against each answer.Blank field would not be counted towards total score.</h6>
                    <div style="height: 200px !important;" v-bar="{preventParentScroll: true}">
                      <table class="table">
                        <tbody>
                          <tr
                            v-for="(k,i) in multipleChoiceData"
                            :key="i"
                            v-if="!(k['in_validation_id'] == 13)"
                          >
                            <td>
                              <img
                                v-if="surveyQuestionWithDetails[modalQid]['qval_15']"
                                class="score-img"
                                :src="k['st_answer_text']"
                              />
                              <label v-else class="modal-label">{{k['st_answer_text']}}</label>
                            </td>
                            <td>
                              <input
                                type="number"
                                min="0"
                                v-model="multipleChoiceData[i]['st_answer_score']"
                                v-validate="'required|numeric|max_value:1000000'"
                                :name="'score '+i"
                                :key="'score '+i"
                                data-vv-as="above"
                                v-on:keypress="isNumberOnly($event)"
                              />
                              <span
                                class="error"
                                v-if="errors.has('score ' + i)"
                              >{{ errors.first('score ' + i)}}</span>
                            </td>
                            <td>
                              <a
                                href="#"
                                @click.prevent="duplicateMultipleValues(i)"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Duplicate all of the following answers"
                              >
                                <i id="copyModalValues" class="fa fa-files-o" aria-hidden="true"></i>
                              </a>
                            </td>
                          </tr>
                          <!-- Input for others if allow other answers validation is set to true -->
                          <tr
                            v-if="multipleChoiceData[Object.keys(multipleChoiceData)[0]] && multipleChoiceData[Object.keys(multipleChoiceData)[0]]['in_validation_id'] == 13"
                          >
                            <td>
                              <label class="modal-label">Other</label>
                            </td>
                            <td>
                              <input
                                type="number"
                                v-model="multipleChoiceData[Object.keys(multipleChoiceData)[0]]['st_answer_score']"
                                v-validate="'required|numeric|max_value:1000000'"
                                :name="'score '+Object.keys(multipleChoiceData)[0]"
                                :key="'score '+Object.keys(multipleChoiceData)[0]"
                                data-vv-as="above"
                                v-on:keypress="isNumberOnly($event)"
                              />
                              <span
                                class="error"
                                v-if="errors.has('score '+Object.keys(multipleChoiceData)[0])"
                              >{{ errors.first('score '+Object.keys(multipleChoiceData)[0])}}</span>
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- <div class="form-group" v-for="(k,i) in multipleChoiceData" :key="i">
                    <div v-if="!(k['in_validation_id'] == 13)">
                      <img
                        v-if="surveyQuestionWithDetails[modalQid]['qval_15']"
                        class="score-img"
                        :src="k['st_answer_text']"
                      >
                      <label v-else class="modal-label">{{k['st_answer_text']}}</label>
                      <input
                        type="number"
                        v-model="multipleChoiceData[i]['st_answer_score']"
                        v-validate="'required|numeric|min_value:-1000000|max_value:1000000'"
                        :name="'score '+i"
                        :key="'score '+i"
                        data-vv-as="above"
                      >
                      <a
                        href="#"
                        @click.prevent="duplicateMultipleValues(i)"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Duplicate all of the following answers"
                      >
                        <i id="copyModalValues" class="fa fa-files-o" aria-hidden="true"></i>
                      </a>
                      <span
                        class="error"
                        v-if="errors.has('score ' + i)"
                      >{{ errors.first('score ' + i)}}</span>
                    </div>
                    </div>-->
                    <!-- Input for others if allow other answers validation is set to true -->
                    <!-- <div
                    class="form-group"
                    v-if="multipleChoiceData[Object.keys(multipleChoiceData)[0]] && multipleChoiceData[Object.keys(multipleChoiceData)[0]]['in_validation_id'] == 13"
                  >
                    <label class="modal-label">Other</label>
                    <input
                      type="number"
                      v-model="multipleChoiceData[Object.keys(multipleChoiceData)[0]]['st_answer_score']"
                      v-validate="'required|numeric|min_value:-1000000|max_value:1000000'"
                      :name="'score '+Object.keys(multipleChoiceData)[0]"
                      :key="'score '+Object.keys(multipleChoiceData)[0]"
                      data-vv-as="above"
                    >
                    <span
                      class="error"
                      v-if="errors.has('score '+Object.keys(multipleChoiceData)[0])"
                    >{{ errors.first('score '+Object.keys(multipleChoiceData)[0])}}</span>
                    </div>-->
                  </form>
                  <h6 class="text-danger" v-if="surveyQuestionWithDetails[modalQid] && surveyQuestionWithDetails[modalQid][20] && surveyQuestionWithDetails[modalQid][20]['st_answer_text'] == 1">Question with allow more than one answers cannot have audit feature.</h6>
                  </div>
                <!-- <div slot="modal-ok">
                <a href="#">save changes</a>
              </div>
              <div slot="modal-cancel">
                <a href="#">cancel</a>
                </div>-->
                <div class="survey_settings row">
                  <div class="col-md-6">
                    <div class="end_save_btn save_reset">
                      <a class="btn-reset" href="#" @click.prevent="removeAudit">
                        <span>remove settings</span>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="end_save_btn save_cancel paddingB0">
                      <a class="btn-cancel" href="#" @click.prevent="closeModal">Cancel</a>
                      <a class="btn-whitelable" href="#" @click.prevent="saveScore">
                        <span>Save</span>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- <a href="#">Remove Settings</a>
                <a class="btn-cancel" href="#">Cancel</a>
                <a class="btn-whitelable" href="#">Save Changes</a>-->
              </b-modal>
            </div>
          </div>
        </div>
        <div class="row extra-drag-area" v-if="all.in_status == vueCommonConfig.SURVEY_DRAFT && questionLists.length > 0">
          <div class="question_colume">
            <div class="panel-group" id="accordion">
              <draggable
                v-model="questionListsTemp"
                class="temp-drag-box dragArea icon-edit dragAreaMessage"
                @change="onChangeTempArea"
                :options="dragOptions"
              ></draggable>
            </div>
          </div>
        </div>
        <!-- End screen code -->
        <div
          v-if="questionStartEnd.end && endActivate === 1"
          class="row"
          @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : questionChanged($event, -3)"
        >
          <div
            :data-que-id="questionStartEnd['end']['in_question_master_id']"
            :data-que-type-id="questionStartEnd['end']['in_question_type_id']"
            :data-id="questionStartEnd['end']['question_type_details'] ? questionStartEnd['end']['question_type_details']['in_control_id']:''"
            :data-controlName="'End screen'"
            :data-className="'fa fa-stop-circle-o'"
            :class="currentQuestion == -3 ? 'question_colume selectedQuestion' : 'question_colume'"
          >
            <div class="panel-group" id="accordion">
              <div class="end panel panel-default">
                <div class="panel-heading">
                  <span
                    :class="questionLists.length > 99 ? 'width40px' : 'width30px'"
                    v-if="questionLists.length > 0"
                  >{{questionLists.length + 1}}</span>
                  <h4 class="panel-title">
                    <i class="fa fa-stop-circle-o activeStartEndScreen" aria-hidden="true"></i>
                    <a
                      href="#"
                      data-toggle="collapse"
                      data-parent="#accordion"
                      class="collapse-new"
                    >
                      End Screen
                      <i
                        id="endExpandCollapse"
                        :class="endCollapsed ? 'accordion-toggle collapsed' : 'accordion-toggle'"
                        v-on:click.prevent="endCollapsed = !endCollapsed"
                        aria-hidden="true"
                      ></i>
                    </a>
                    <ul class="nav question_option">
                      <li>
                        <a
                          href="#"
                          @click.prevent
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Activate/Deactivate End Screen"
                        >
                          <i
                            :data-que-id="questionStartEnd['end']['in_question_master_id']"
                            :data-que-type-id="questionStartEnd['end']['in_question_type_id']"
                            :data-id="questionStartEnd['end']['question_type_details'] ? questionStartEnd['end']['question_type_details']['in_control_id']:''"
                            :data-controlName="'End screen'"
                            class="endActivateIcon fa fa-trash-o"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </li>
                    </ul>
                  </h4>
                </div>
                <div
                  v-if="!endCollapsed"
                  :class="currentQuestion == -3 ? 'panel-collapse collapse in show selectedQuestion' :'panel-collapse collapse in show'"
                >
                  <expanddisplay :qid="questionStartEnd['end']['in_question_master_id']"></expanddisplay>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="endActivate === 0 && (startActivate === 1 || questionLists.length > 0)"
          class="row"
        >
          <div class="question_colume">
            <div class="panel-group" id="accordion">
              <div class="end panel panel-default">
                <div
                  class="panel-heading"
                  @click="questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : questionChanged($event, -3)"
                >
                  <h4
                    class="panel-title endActivateIcon deactivated"
                    :data-que-id="questionStartEnd['end']['in_question_master_id']"
                    :data-que-type-id="questionStartEnd['end']['in_question_type_id']"
                    :data-id="questionStartEnd['end']['question_type_details'] ? questionStartEnd['end']['question_type_details']['in_control_id']:''"
                    :data-className="'fa fa-stop-circle-o'"
                    :data-controlName="'End screen'"
                  >
                    <i class="deactivate fa fa-stop-circle-o" aria-hidden="true"></i>
                    <a
                      href="#"
                      class="endActivateIcon"
                      data-toggle="collapse"
                      data-parent="#accordion"
                    >Click to add End Screen</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="question_colume" v-if="startActivate === 1 || questionLists.length > 0">
            <div class="panel-group" id="accordion">
              <div
                class="end panel panel-default"
                @click.prevent=" questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : (addStartEndScreen(-3))"
              >
                <div class="panel-heading">
                  <h4 class="panel-title endActivateIcon deactivated" @click.prevent>
                    <i class="deactivate fa fa-stop-circle-o" aria-hidden="true"></i>
                    <a href="#" class="endActivateIcon" @click.prevent>Click to add End Screen</a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <back-to-top visibleoffset="300" bottom="50px" right="50px">
      <button type="button" class="btn btn-info btn-to-top">
        <i class="fa fa-chevron-up"></i>
      </button>
    </back-to-top>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import draggable from "vuedraggable";
import emptyquestion from "./emptyquestion";
import expanddisplay from "./expanddisplay";
var {
  queTypeConfig,
  queControlConfig,
  constantCommonConfig
} = require("../../../config/config.js");

export default {
  name: "centerquestions",
  components: {
    draggable,
    emptyquestion,
    expanddisplay
  },
  data() {
    return {
      startCollapsed: true,
      endCollapsed: true,
      isExpandEnabled: 0,
      isExpand: false,
      queindex: -1,
      startActivate: 1,
      endActivate: 1,
      inEmailDatePhoto: 0,
      dragOptions: {
        group: "people"
      },
      sortingInterval: 1000,
      questionLists: [],
      questionIds: [],
      questionData: [],
      currentQuestion: -4,
      getQuestionData: [],
      questionStartEnd: {},
      modalQid: -1,
      ansArrayValues: [],
      modalQtypeId: -1,
      modalQindex: -1,
      multipleChoiceData: {},
      modalSaveObj: [],
      scoreOther: "",
      questionListsTemp: [],
      smileyClass: {
        ":)": "em em-smile",
        ":|": "em em-neutral_face",
        ":P": "em em-heart_eyes",
        ":@": "em em-angry",
        ":(": "em em-disappointed"
      },
      questInSkipLogic: new Set(),
      mySetChangeTracker: 1,
      skipLogicAnsDetails: {},
      confirmMinQ: -4,
      confirmMaxQ: -4,
      vueCommonConfig: constantCommonConfig,
      smileyAnsVal: ""
    };
  },
  computed: {
    // for icons above start screen
    ...mapGetters("LeftSidebarCreate", ["all", "surveytypes"]),
    ...mapGetters("editquestionEdit", {
      myQuestion: "getQuestionAll",
      questUpdated: "questionUpdated",
      surveyStartEndQuest: "surveyStartEndQuestions",
      copyQuestionAll: "getCopyQuestionAll",
      surveyQuestionWithDetails: "getSurveyQuestWithDetails",
      surveyQuestionAnswerWithScore: "getSurveyQuestionAnswerWithScore",
      getSkipLogicDetails: "getSkipLogicDetails",
      skipLogicRetrieved: "skipLogicRetrieved",
      currentQno: "currentQno",
      skipLogicStartQ: "skipLogicStartQ",
      skipLogicEndQ: "skipLogicEndQ",
      skipLogicEndScreen: "skipLogicEndScreen",
      surveyQuestions: "surveyQuestions",
      calledBefore: "calledBefore"
    }),
    mySetAsList() {
      return this.mySetChangeTracker && Array.from(this.questInSkipLogic);
    }
  },
  async created() {
    this.getQuestionData.sessionData = this.$session.getAll();
    this.questionData = this.$session.getAll();
    this.getQuestionData.sessionData["in_survey_Id"] = this.$route.params.id;
    this.questionData["in_survey_Id"] = this.$route.params.id;
    this.currentQuestion = this.currentQno;
    if (!this.calledBefore) {
      await this.getSurveyData(this.questionData).then(value => {
        // this.questionLists = this.$store.getters[
        //   "editquestionEdit/surveyQuestions"
        // ];
        this.questionLists = this.surveyQuestions;
        this.questionLists .forEach(element => {
          this.incrementKioskQuestionCount();
        });
        this.questionLists.forEach(e => {
          if(e.in_question_type_id == 18){
            this.incrementPhotoQuestionCount();
          }
        });
      });
      await this.getSurveyStartEndData(this.questionData).then(value => {
        this.questionStartEnd = this.surveyStartEndQuest;
        this.startActivate = this.questionStartEnd["start"]
          ? this.questionStartEnd["start"]["in_status"]
          : "";
        this.endActivate = this.questionStartEnd["end"]
          ? this.questionStartEnd["end"]["in_status"]
          : "";
      });
      await this.getSurveyQuestionWithDetails(this.questionData).then(value => {
        this.isExpandEnabled = 1;
      });
    } else {
      // this.questionLists = this.$store.getters[
      //   "editquestionEdit/surveyQuestions"
      // ];
      this.questionLists = this.surveyQuestions;

      this.questionStartEnd = this.surveyStartEndQuest;
      this.startActivate = this.questionStartEnd["start"]
        ? this.questionStartEnd["start"]["in_status"]
        : "";
      this.endActivate = this.questionStartEnd["end"]
        ? this.questionStartEnd["end"]["in_status"]
        : "";

      this.isExpandEnabled = 1;
    }
    if (!this.skipLogicRetrieved) {
      await this.getSkipLogicRules(this.questionData).then(() => {
        this.updateSkipLogicIcons();
        console.log("hhhh");
        this.setCurrentQuestion();
      });
    } else {
      this.updateSkipLogicIcons();
    }
  },
  mounted() {
    EventBus.$on("questionSaved", qtype => {
      let obj = this.questionLists.find(x => {
        if (x.in_question_master_id) {
          return x.in_question_master_id == qtype.in_question_master_id;
        } else {
          return x.dbQueId == qtype.in_question_master_id;
        }
      });

      if (obj) {
        let index = this.questionLists.indexOf(obj);
        // For setting audit off on save of question
        // inAuditFlag => if we changed only answer (not other validation like required, address question etc.) then we need to disable audit flag
        if(this.all.in_status == constantCommonConfig.SURVEY_DRAFT) {
          if(qtype.inAuditFlag == 0)
            this.$set(this.questionLists[index], "in_audit", 0);
          else
            this.$set(this.questionLists[index], "in_audit", 1);
        }
        // For updating required message if question type changed from text to display
        if (
          qtype.in_question_type_id === queTypeConfig.TYPE_INPUT ||
          qtype.in_question_type_id === queTypeConfig.TYPE_DISPLAY
        ) {
          this.$set(
            this.questionLists[index],
            "in_question_type_id",
            qtype.in_question_type_id
          );
        }
        this.$set(
          this.questionLists[index],
          "st_question_title",
          qtype.st_question_title
        );
        if (qtype.validationDetails[1] !== "") {
          if (!qtype.validationDetails[1]) {
            var tempArr = {};

            this.setRequired("0", index);
          } else {
            var tempArr = {};

            this.setRequired("1", index);
          }
        }
      }
    });

    EventBus.$on("addQuestionOnDbClick", evt => {
      evt.added.newIndex = this.questionLists.length;
      this.onChange(evt);
    });
    this.setCurrentQuestion();
    // setTimeout(() => {
    //   // For opening selected question in right panel when returned back from skip logic section
    //   if (this.currentQuestion !== -4) {
    //     console.log(document.querySelector(".selectedQuestion"));
    //     if (
    //       document.querySelector(".selectedQuestion") &&
    //       document
    //         .querySelector(".selectedQuestion")
    //         .firstChild.getAttribute("data-id")
    //     ) {
    //       this.$nextTick(function() {
    //         var obj = [];
    //         // control Id
    //         obj["id"] = document
    //           .querySelector(".selectedQuestion")
    //           .firstChild.getAttribute("data-id");
    //         // Question Index id
    //         obj["qid"] = this.currentQuestion + 1;
    //         // Db question Id
    //         obj["in_question_master_id"] = document
    //           .querySelector(".selectedQuestion")
    //           .firstChild.getAttribute("data-que-id");
    //         // Control Name
    //         obj["controlName"] = document
    //           .querySelector(".selectedQuestion")
    //           .firstChild.getAttribute("data-controlName");
    //         // Class Name
    //         obj["className"] = document
    //           .querySelector(".selectedQuestion")
    //           .firstChild.getAttribute("data-className");
    //         obj["created"] = 1;

    //         this.getQuestionData.in_question_master_id = document
    //           .querySelector(".selectedQuestion")
    //           .firstChild.getAttribute("data-que-id");
    //         this.getEditData(this.getQuestionData);
    //         EventBus.$emit("questionTypeSelected", obj);
    //       });
    //     } else if (this.currentQuestion === -2 || this.currentQuestion === -3) {
    //       this.$nextTick(function() {
    //         setTimeout(() => {
    //           if (document.querySelector(".selectedQuestion")) {
    //             var obj = [];
    //             // control Id
    //             obj["id"] = document
    //               .querySelector(".selectedQuestion")
    //               .getAttribute("data-id");
    //             // Question Index id
    //             obj["qid"] = this.currentQuestion + 1;
    //             // Db question Id
    //             obj["in_question_master_id"] = document
    //               .querySelector(".selectedQuestion")
    //               .getAttribute("data-que-id");
    //             // Control Name
    //             obj["controlName"] = document
    //               .querySelector(".selectedQuestion")
    //               .getAttribute("data-controlName");
    //             // Class Name
    //             obj["className"] = document
    //               .querySelector(".selectedQuestion")
    //               .getAttribute("data-className");
    //             obj["created"] = 1;

    //             this.getQuestionData.in_question_master_id = document
    //               .querySelector(".selectedQuestion")
    //               .getAttribute("data-que-id");
    //             this.getEditData(this.getQuestionData);
    //             EventBus.$emit("questionTypeSelected", obj);
    //           }
    //         }, 100);
    //       });
    //     }
    //   }
    // }, 200);
  },
  beforeDestroy() {
    EventBus.$off("questionSaved");
    EventBus.$off("addQuestionOnDbClick");
  },
  methods: {
    ...mapActions("editquestionEdit", [
      "getSurveyData",
      "createData",
      "getEditData",
      "deleteQuestion",
      "getSurveyStartEndData",
      "copyQuestionData",
      "activateDeactivateStartEndScreen",
      "addAsRequiredSurveyQuestion",
      "getSurveyQuestionWithDetails",
      "getSurveyQuestWithDetailsByQuestionId",
      "editSurveyAnswerWithScore",
      "editSurveyAnswerWithMultipleScores",
      "getSurveyAnswerWithScore",
      "removeAuditFromSurveyQuestion",
      "getSkipLogicRules",
      "updtSkipLogicStartQ",
      "updtSkipLogicEndQ",
      "updtSkipLogicQid",
      "setIsSkipLogic",
      "setSurveyQuestionsOrder"
    ]),
    ...mapActions("LeftSidebarCreate", [
      "incrementQuestionCount",
      "incrementKioskQuestionCount",
      "decrementQuestionCount",
      "decrementKioskQuestionCount",
      "setSurvey_delete_flag",
      "incrementPhotoQuestionCount",
      "decrementPhotoQuestionCount"
    ]),

    setCurrentQuestion: function() {
      if (this.currentQuestion !== -4) {
        console.log(document.querySelector(".selectedQuestion"));
        if (
          document.querySelector(".selectedQuestion") &&
          document
            .querySelector(".selectedQuestion")
            .firstChild.getAttribute("data-id")
        ) {
          this.$nextTick(function() {
            var obj = [];
            // control Id
            obj["id"] = document
              .querySelector(".selectedQuestion")
              .firstChild.getAttribute("data-id");
            // Question Index id
            obj["qid"] = this.currentQuestion + 1;
            // Db question Id
            obj["in_question_master_id"] = document
              .querySelector(".selectedQuestion")
              .firstChild.getAttribute("data-que-id");
            // Control Name
            obj["controlName"] = document
              .querySelector(".selectedQuestion")
              .firstChild.getAttribute("data-controlName");
            // Class Name
            obj["className"] = document
              .querySelector(".selectedQuestion")
              .firstChild.getAttribute("data-className");
            obj["created"] = 1;

            this.getQuestionData.in_question_master_id = document
              .querySelector(".selectedQuestion")
              .firstChild.getAttribute("data-que-id");
            this.getEditData(this.getQuestionData);
            EventBus.$emit("questionTypeSelected", obj);
          });
        } else if (this.currentQuestion === -2 || this.currentQuestion === -3) {
          this.$nextTick(function() {
            setTimeout(() => {
              if (document.querySelector(".selectedQuestion")) {
                var obj = [];
                // control Id
                obj["id"] = document
                  .querySelector(".selectedQuestion")
                  .getAttribute("data-id");
                // Question Index id
                obj["qid"] = this.currentQuestion + 1;
                // Db question Id
                obj["in_question_master_id"] = document
                  .querySelector(".selectedQuestion")
                  .getAttribute("data-que-id");
                // Control Name
                obj["controlName"] = document
                  .querySelector(".selectedQuestion")
                  .getAttribute("data-controlName");
                // Class Name
                obj["className"] = document
                  .querySelector(".selectedQuestion")
                  .getAttribute("data-className");
                obj["created"] = 1;

                this.getQuestionData.in_question_master_id = document
                  .querySelector(".selectedQuestion")
                  .getAttribute("data-que-id");
                this.getEditData(this.getQuestionData);
                EventBus.$emit("questionTypeSelected", obj);
              }
            }, 100);
          });
        }
      }
    },

    callSaveMethod: function() {
      EventBus.$emit("saveQuestionFromCenterQuestions");
    },
    callCancelMethod: function() {
      EventBus.$emit("cancelQuestionFromCenterQuestions");
    },
    updateSkipLogicIcons() {
      console.log("update iconsss");
      console.log(this.getSkipLogicDetails);
      console.log(this.skipLogicStartQ);
      this.confirmMinQ = this.skipLogicStartQ;
      this.confirmMaxQ = this.skipLogicEndQ;
      Object.keys(this.getSkipLogicDetails).forEach(value => {
        if (this.getSkipLogicDetails[value].length > 0) {
          this.questInSkipLogic.add(parseInt(value));
          this.getSkipLogicDetails[value].forEach(val => {
            if (this.confirmMaxQ < parseInt(val.in_then_question_number)) {
              this.confirmMaxQ = parseInt(val.in_then_question_number);
            }
            if (this.confirmMaxQ < parseInt(val.in_else_question_number)) {
              this.confirmMaxQ = parseInt(val.in_else_question_number);
            }
            // this.questInSkipLogic.add(parseInt(val.in_then_question_id));
            // this.questInSkipLogic.add(parseInt(val.in_else_question_id));
            val.rules_array.forEach(ansval => {
              // Code to check if min qno with skiplogic is present in rule details table and updating the qno.
              if (ansval[0] && ansval[0].length > 0) {
                let ruleQnoIndex = this.questionLists.findIndex(
                  item =>
                    item.in_question_master_id ===
                    ansval[0]["in_question_master_id"]
                );

                if (
                  this.confirmMinQ >
                  this.questionLists[ruleQnoIndex]["in_question_number"]
                ) {
                  this.confirmMinQ = this.questionLists[ruleQnoIndex][
                    "in_question_number"
                  ];
                }
              }
              ansval.forEach(ansdet => {
                this.questInSkipLogic.add(ansdet.in_question_master_id);
                if (ansdet["st_answer_value"] !== "NA") {
                  if (!this.skipLogicAnsDetails[ansdet.in_question_master_id])
                    this.skipLogicAnsDetails[ansdet.in_question_master_id] = [];
                  this.skipLogicAnsDetails[ansdet.in_question_master_id].push(
                    ansdet["st_answer_value"]
                  );
                }
              });
            });
          });
        }
      });
      console.log(this.confirmMinQ);
      if (this.confirmMinQ !== this.skipLogicStartQ)
        this.updtSkipLogicStartQ(this.confirmMinQ);
      if (this.confirmMaxQ !== this.skipLogicEndQ)
        this.updtSkipLogicEndQ(this.confirmMaxQ);
      this.updtSkipLogicQid(this.questInSkipLogic);
      this.mySetChangeTracker += 1;
    },
    addStartEndScreen: function(val) {
      // if (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED) {
      if (val === -2) {
        this.questionData.in_question_type_id =
          queControlConfig.CONTROL_START_SCREEN;
        this.questionData.in_question_number = -1;
        this.questionData.in_question_order = -1;
        this.questionData.st_question_title = "Start Screen";
        this.questionData.st_control_name = "Start Screen";
        this.questionData.st_class_name = "fa fa-play-circle-o";
        this.createData(this.questionData).then(value => {
          if (this.surveyStartEndQuest && this.surveyStartEndQuest.start) {
            this.$set(
              this.questionStartEnd,
              "start",
              this.surveyStartEndQuest.start
            );
            this.startActivate = 1;
          }
          if (this.surveyStartEndQuest && this.surveyStartEndQuest.end) {
            this.$set(
              this.questionStartEnd,
              "end",
              this.surveyStartEndQuest.end
            );
            this.endActivate = 1;
          }
          this.questionStartEnd = Object.assign({}, this.questionStartEnd);
          let queData = [];
          queData.in_question_master_id = this.myQuestion.in_question_master_id;
          // evt.item.in_question_master_id = this.myQuestion.in_question_master_id
          queData.id = queControlConfig.CONTROL_START_SCREEN;
          queData.qid = -1;
          queData.controlName = "Start Screen";
          queData.className = "fa fa-play-circle-o";
          queData.created = 1;
          EventBus.$emit("questionTypeSelected", queData);
        });
      } else {
        if (!this.skipLogicEndScreen) {
          this.questionData.in_question_type_id =
            queControlConfig.CONTROL_END_SCREEN;
          this.questionData.in_question_number = -2;
          this.questionData.in_question_order = -2;
          this.questionData.st_question_title = "End Screen";
          this.questionData.st_control_name = "End Screen";
          this.questionData.st_class_name = "fa fa-stop-circle-o";
          this.createData(this.questionData).then(value => {
            if (this.surveyStartEndQuest && this.surveyStartEndQuest.start) {
              this.$set(
                this.questionStartEnd,
                "start",
                this.surveyStartEndQuest.start
              );
              this.startActivate = 1;
            }
            if (this.surveyStartEndQuest && this.surveyStartEndQuest.end) {
              this.$set(
                this.questionStartEnd,
                "end",
                this.surveyStartEndQuest.end
              );
              this.endActivate = 1;
            }
            this.questionStartEnd = Object.assign({}, this.questionStartEnd);
            let queData = [];
            queData.in_question_master_id = this.myQuestion.in_question_master_id;
            // evt.item.in_question_master_id = this.myQuestion.in_question_master_id
            queData.id = queControlConfig.CONTROL_END_SCREEN;
            queData.qid = -2;
            queData.controlName = "End Screen";
            queData.className = "fa fa-stop-circle-o";
            queData.created = 1;
            EventBus.$emit("questionTypeSelected", queData);
          });
        }
      }
      // }
    },
    onChangeTempArea: function(/** Event */ evt) {
      evt.added.newIndex = this.questionLists.length;
//      this.questionListsTemp.length > 0
//        ? this.$set(
//            this.questionLists,
//            evt.added.newIndex,
//            this.questionListsTemp[0]
//          )
//        : "";
      this.questionListsTemp = [];
      this.onChange(evt);
    },
    onChange: function(/** Event */ evt) {
      console.log("in here");
      if (evt.added) {
        this.$wait.start("creating question");
        let arrayIndex = evt.added.newIndex;
        // if (
        //   evt.added.element.in_control_id == 5
        //     ? (this.inEmailDatePhoto = 1)
        //     : evt.added.element.in_control_id == 11
        //       ? (this.inEmailDatePhoto = 2)
        //       : evt.added.element.in_control_id == 8
        //         ? (this.inEmailDatePhoto = 3)
        //         : ''
        // ) {
        //   this.queindex = evt.added.newIndex
        // }
        // Create default question here
        this.currentQuestion = arrayIndex;
        this.questionData.in_question_type_id = evt.added.element.in_control_id;
//        this.questionData.in_question_number =
//          evt.added.element.is_double_clicked === true
//            ? this.questionLists.length + 1
//            : this.questionLists.length;
        this.questionData.in_question_number = arrayIndex + 1;
        this.questionData.in_question_order = arrayIndex + 1;
        this.questionData.st_question_title =
          evt.added.element.st_control_name + " Question";
        this.questionData.st_control_name = evt.added.element.st_control_name;
        this.questionData.st_class_name = evt.added.element.st_class_name;
        this.questionData.sessionData = this.$session.getAll();
        this.questionData.sessionData["in_survey_Id"] = this.$route.params.id;
        this.createData(this.questionData).then(value => {
          this.questionLists = this.surveyQuestions;
          this.incrementQuestionCount();
          this.incrementKioskQuestionCount();
        if(this.questionData.in_question_type_id == 11){
          this.incrementPhotoQuestionCount();
        }
          let updatedQuestion = {};
          if (evt.added.element.is_double_clicked) {
            updatedQuestion = Object.assign(
              {},
              this.questionLists[arrayIndex],
              {
                dbQueId: this.myQuestion.in_question_master_id,
                in_question_type_id: this.myQuestion.in_question_type_id,
                in_control_id: evt.added.element.in_control_id,
                st_class_name: evt.added.element.st_class_name,
                in_is_mobile_control: evt.added.element.in_is_mobile_control,
                st_control_name: evt.added.element.st_control_name
              }
            );
            // this.surveyQuestions.push(updatedQuestion);
          } else {
            updatedQuestion = Object.assign(
              {},
              this.questionLists[arrayIndex],
              {
                dbQueId: this.myQuestion.in_question_master_id,
                in_question_type_id: this.myQuestion.in_question_type_id
              }
            );
            // this.surveyQuestions.push(updatedQuestion);
          }

          // this.questionLists[arrayIndex] = {};
          // this.questionLists[arrayIndex] = updatedQuestion;
          this.$set(this.questionLists, arrayIndex, {});
          this.$set(this.questionLists, arrayIndex, updatedQuestion);
          let queData = [];
          queData.in_question_master_id = this.myQuestion.in_question_master_id;
          // evt.item.in_question_master_id = this.myQuestion.in_question_master_id
          queData.id = evt.added.element.in_control_id;
          queData.qid = arrayIndex + 1;
          queData.controlName = evt.added.element.st_control_name;
          queData.className = evt.added.element.st_class_name;
          queData.created = 1;
          EventBus.$emit("questionTypeSelected", queData);
          this.questionIds = [];
          // this.questionLists.forEach((value, key) => {
          //   if (value['dbQueId']) {
          //     this.questionIds.push(value['dbQueId'])
          //   } else {
          //     this.questionIds.push(value['in_question_master_id'])
          //   }
          // })
          // this.questionData.questionDetails = this.questionIds
          // this.setSurveyQuestionsOrder(this.questionData)

          // Update the survey delete flag. it is used to delete survey if question is zero
          this.updateSurveyDeleteFlag();
          this.$wait.end("creating question");
        });
      } else {
      }
    },
    onSort: function(/** Event */ evt) {
      this.$wait.start("creating question");
      // Set current question index
      if (evt.clone.classList.contains("selectedQuestion")) {
        // if selected question is sort
        this.currentQuestion = evt.newIndex;
      } else if (evt.item.classList.contains("selectedQuestion")) {
        // if selected question sort from top to bottom / bottom to top
        this.currentQuestion =
          evt.newIndex < evt.oldIndex ? evt.newIndex + 1 : evt.newIndex - 1;
      }
      setTimeout(() => {
        this.questionIds = [];
        this.questionLists.forEach((value, key) => {
          if (value["dbQueId"]) {
            this.questionIds.push(value["dbQueId"]);
          } else {
            this.questionIds.push(value["in_question_master_id"]);
          }
        });
        this.questionData.questionDetails = this.questionIds;
        this.setSurveyQuestionsOrder(this.questionData).then(() => {
          this.$wait.end("creating question");
        });
        this.currentQuestion = evt.newIndex;

        let queData = [];
        queData.in_question_master_id = this.questionLists[evt.newIndex]
          .in_question_master_id
          ? this.questionLists[evt.newIndex].in_question_master_id
          : this.questionLists[evt.newIndex].dbQueId;
        queData.id = this.questionLists[evt.newIndex].question_type_details
          ? this.questionLists[evt.newIndex].question_type_details
              .control_details.in_control_id
          : this.questionLists[evt.newIndex].in_control_id;
        queData.qid = evt.newIndex + 1;
        queData.controlName = this.questionLists[evt.newIndex]
          .question_type_details
          ? this.questionLists[evt.newIndex].question_type_details
              .control_details.st_control_name
          : this.questionLists[evt.newIndex].st_control_name;
        queData.className = this.questionLists[evt.newIndex]
          .question_type_details
          ? this.questionLists[evt.newIndex].question_type_details
              .control_details.st_class_name
          : this.questionLists[evt.newIndex].st_class_name;
        this.getQuestionData.in_question_master_id = this.questionLists[
          evt.newIndex
        ].in_question_master_id
          ? this.questionLists[evt.newIndex].in_question_master_id
          : this.questionLists[evt.newIndex].dbQueId;
        this.getEditData(this.getQuestionData);
        EventBus.$emit("questionTypeSelected", queData);
      }, this.sortingInterval);
    },
    async questionChanged(evt, index) {
      if (evt.srcElement.id === "requiredIcon") {
        // Commented as even if the question is in skiplogic mandatory validation can be changed
        // if (
        //   !(this.confirmMinQ - 1 <= index && index <= this.skipLogicEndQ - 1)
        // ) {

        // Required option is not avaialble for Image and Display text question type
        // 17 => Image
        // 2 => Display Text
        if (
          evt.currentTarget.firstChild.getAttribute("data-que-type-id") ==
            queTypeConfig.TYPE_IMAGE ||
          evt.currentTarget.firstChild.getAttribute("data-que-type-id") ==
            queTypeConfig.TYPE_DISPLAY
        ) {
        } else {
          this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-id"
          );
          this.getQuestionData.is_required_selected = evt.srcElement.getAttribute(
            "data-isrequired"
          );
          this.setRequired(
            evt.srcElement.getAttribute("data-isrequired"),
            index
          );
          this.addAsRequiredSurveyQuestion(this.getQuestionData);
        }
      } else if (evt.srcElement.id === "deleteIcon") {
        if (
          this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED &&
          !(this.confirmMinQ - 1 <= index && index <= this.skipLogicEndQ - 1)
        ) {
          let tempId = evt.currentTarget.firstChild.getAttribute("data-qid");
          let tempQid = evt.currentTarget.firstChild.getAttribute(
            "data-que-id"
          );
          let tempQtypeid = evt.currentTarget.firstChild.getAttribute(
            "data-que-type-id"
          );

          let selectedQuestionClassExist =
            evt.currentTarget.firstChild.classList.contains(
              "selectedQuestion"
            ) || evt.currentTarget.classList.contains("selectedQuestion");
          this.$awn.confirm(
            "Are you sure you want to delete this question?",
            () => {
              // this.questionLists.splice(tempId - 1, 1);
              this.getQuestionData.in_question_master_id = tempQid;
              this.getQuestionData.in_question_type_id = tempQtypeid;
              this.getQuestionData.in_question_index = tempId - 1;
              // If selected question is deleted then set blank right settings screen
              if (selectedQuestionClassExist) {
                this.currentQuestion = -4; // Remove selectedQuestion class from question list
                var obj = [];
                EventBus.$emit("questionTypeSelected", obj);
              } else {
                // Update question number on right side if deleted index is greater than selected question
                if (this.currentQuestion >= tempId) {
                  var obj = [];
                  // control Id

                  //  Not needed after skip logic changes and updating store variables
                  // obj["id"] = document
                  //   .querySelector(".selectedQuestion")
                  //   .firstChild.getAttribute("data-id");
                  // // Question Index id
                  // obj["qid"] = this.currentQuestion;
                  // // Db question Id
                  // obj["in_question_master_id"] = document
                  //   .querySelector(".selectedQuestion")
                  //   .firstChild.getAttribute("data-que-id");
                  // // Control Name
                  // obj["controlName"] = document
                  //   .querySelector(".selectedQuestion")
                  //   .firstChild.getAttribute("data-controlName");
                  // // Class Name
                  // obj["className"] = document
                  //   .querySelector(".selectedQuestion")
                  //   .firstChild.getAttribute("data-className");

                  // EventBus.$emit("questionTypeSelected", obj);
                  // upto here
                  this.currentQuestion = this.currentQuestion - 1;
                }
              }
              this.$wait.start("creating question");
              this.deleteQuestion(this.getQuestionData).then(() => {
                this.questionLists = this.surveyQuestions;
                this.decrementQuestionCount();
                this.decrementKioskQuestionCount();
                if(tempQtypeid==18){
                  this.decrementPhotoQuestionCount();
                };
                this.questionIds = [];
                this.questionLists.forEach((value, key) => {
                  if (value["dbQueId"]) {
                    this.questionIds.push(value["dbQueId"]);
                  } else {
                    this.questionIds.push(value["in_question_master_id"]);
                  }
                });
                this.questionData.questionDetails = this.questionIds;
//                this.setSurveyQuestionsOrder(this.questionData); //this is moved to server side
                // Update the survey delete flag. it is used to delete survey if question is zero
                this.updateSurveyDeleteFlag();
                this.$wait.end("creating question");
              });
            }
          );
        } else {
          this.$awn.alert("You cannot do any chnages to this question");
        }
      } else if (evt.srcElement.id === "copyIcon") {
        if (
          this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED &&
          !(this.confirmMinQ - 1 <= index && index <= this.skipLogicEndQ - 1)
        ) {
          this.$wait.start("creating question");
          var previousData = this.questionLists[index];
          var arrayIndex = index + 1;
          this.getQuestionData.in_question_type_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-type-id"
          );
          this.getQuestionData.in_control_id = evt.currentTarget.firstChild.getAttribute(
            "data-id"
          );
          this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-id"
          );
          this.getQuestionData.st_control_name = evt.currentTarget.firstChild.getAttribute(
            "data-controlname"
          );
          this.getQuestionData.st_class_name = evt.currentTarget.firstChild.getAttribute(
            "data-classname"
          );
          this.copyQuestionData(this.getQuestionData).then(value => {
            this.incrementQuestionCount();
            if(this.getQuestionData.in_question_type_id == 18){
                  this.incrementPhotoQuestionCount();
                };
            // Not needed now as copy question updated to store variable is done
            // const updatedQuestion = {
            //   dbQueId: this.copyQuestionAll.in_question_master_id,
            //   in_audit: this.copyQuestionAll.in_audit,
            //   dt_created_at: this.copyQuestionAll.dt_created_at,
            //   dt_updated_at: this.copyQuestionAll.dt_updated_at,
            //   in_control_id:
            //     typeof previousData.in_control_id !== "undefined"
            //       ? previousData.in_control_id
            //       : previousData.question_type_details.control_details
            //           .in_control_id,

            // in_control_order:
            //   typeof previousData.in_control_order !== "undefined"
            //     ? previousData.in_control_order
            //     : previousData.question_type_details.control_details
            //         .in_control_order,
            // in_control_title_id:
            //   typeof previousData.in_control_title_id !== "undefined"
            //     ? previousData.in_control_title_id
            //     : previousData.question_type_details.control_details
            //         .in_control_title_id,
            // in_group_id:
            //   typeof previousData.in_group_id !== "undefined"
            //     ? previousData.in_group_id
            //     : previousData.question_type_details.control_details
            //         .in_group_id,
            //   in_is_mobile_control:
            //     typeof previousData.in_is_mobile_control !== "undefined"
            //       ? previousData.in_is_mobile_control
            //       : previousData.question_type_details.control_details
            //           .in_is_mobile_control,
            //   in_question_type_id: this.copyQuestionAll.in_question_type_id,
            //   st_class_name:
            //     typeof previousData.st_class_name !== "undefined"
            //       ? previousData.st_class_name
            //       : previousData.question_type_details.control_details
            //           .st_class_name,
            //   st_control_name:
            //     typeof previousData.st_control_name !== "undefined"
            //       ? previousData.st_control_name
            //       : previousData.question_type_details.control_details
            //           .st_control_name
            // };

            // Insert copied element
            // this.questionLists.splice(arrayIndex, 0, updatedQuestion);

            //
            // this.$set(
            //   this.questionLists[arrayIndex],
            //   "st_question_title",
            //   this.copyQuestionAll.st_question_title
            // );
            // Set required field validation if avaialable
            if (
              this.copyQuestionAll.isRequired &&
              this.copyQuestionAll.in_question_type_id !=
                queTypeConfig.TYPE_IMAGE &&
              this.copyQuestionAll.in_question_type_id !=
                queTypeConfig.TYPE_DISPLAY
            ) {
              this.getQuestionData.in_question_master_id = this.copyQuestionAll.in_question_master_id;
              this.getQuestionData.is_required_selected = this.copyQuestionAll.isRequired;

              this.setRequired(
                this.getQuestionData.is_required_selected,
                arrayIndex
              );
              this.addAsRequiredSurveyQuestion(this.getQuestionData);
            }

            this.questionLists = this.surveyQuestions;
            this.questionIds = [];
            this.questionLists.forEach((value, key) => {
              if (value["dbQueId"]) {
                this.questionIds.push(value["dbQueId"]);
              } else {
                this.questionIds.push(value["in_question_master_id"]);
              }
            });
            this.questionData.questionDetails = this.questionIds;
//            this.setSurveyQuestionsOrder(this.questionData); //this is moved to server side
            this.$wait.end("creating question");
          });
        } else {
          this.$awn.alert("You cannot do any chnages to this question");
        }
      } else if (evt.srcElement.className.includes("startActivateIcon")) {
        // if (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED) {
        this.startActivate == 1
          ? (this.startActivate = 0)
          : (this.startActivate = 1);
        this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
          "data-que-id"
        );
        this.getQuestionData.in_question_type_id = evt.currentTarget.firstChild.getAttribute(
          "data-que-type-id"
        );
        this.getQuestionData.is_active_inactive = this.startActivate;
        this.activateDeactivateStartEndScreen(this.getQuestionData);
        this.updateSurveyDeleteFlag();
        var obj = [];
        if (this.startActivate === 0) {
          this.startCollapsed = true;
          EventBus.$emit("questionTypeSelected", obj);
          this.setExpandIcon();
        } else {
          this.currentQuestion = index;
          obj["id"] = evt.currentTarget.firstChild.getAttribute("data-id");
          obj["qid"] = evt.currentTarget.firstChild.getAttribute("data-qid");
          obj[
            "in_question_master_id"
          ] = evt.currentTarget.firstChild.getAttribute("data-que-id");
          obj["controlName"] = evt.currentTarget.firstChild.getAttribute(
            "data-controlName"
          );
          obj["className"] = evt.currentTarget.firstChild.getAttribute(
            "data-className"
          );
          this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-id"
          );
          this.getEditData(this.getQuestionData);
          EventBus.$emit("questionTypeSelected", obj);
        }
        // } else {
        //   this.$awn.alert("You cannot do any chnages to the start screen");
        // }
      } else if (evt.srcElement.className.includes("endActivateIcon")) {
        console.log(index);
        if (!this.skipLogicEndScreen) {
          this.endActivate == 1
            ? (this.endActivate = 0)
            : (this.endActivate = 1);
          this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-id"
          );
          this.getQuestionData.in_question_type_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-type-id"
          );
          this.getQuestionData.is_active_inactive = this.endActivate;
          this.activateDeactivateStartEndScreen(this.getQuestionData);
          this.updateSurveyDeleteFlag();
          var obj = [];
          if (this.endActivate === 0) {
            this.endCollapsed = true;
            EventBus.$emit("questionTypeSelected", obj);
            this.setExpandIcon();
          } else {
            this.currentQuestion = index;
            obj["id"] = evt.currentTarget.firstChild.getAttribute("data-id");
            obj["qid"] = evt.currentTarget.firstChild.getAttribute("data-qid");
            obj[
              "in_question_master_id"
            ] = evt.currentTarget.firstChild.getAttribute("data-que-id");
            obj["controlName"] = evt.currentTarget.firstChild.getAttribute(
              "data-controlName"
            );
            obj["className"] = evt.currentTarget.firstChild.getAttribute(
              "data-className"
            );
            this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
              "data-que-id"
            );
            this.getEditData(this.getQuestionData);
            EventBus.$emit("questionTypeSelected", obj);
          }
        } else {
          this.$awn.alert("You cannot do any chnages to the end screen");
        }
      } else if (
        evt.srcElement.id === "expandCollapse" ||
        evt.srcElement.id === "startExpandCollapse" ||
        evt.srcElement.id === "endExpandCollapse"
      ) {
        if (this.isExpandEnabled) {
          this.setExpandIcon();
        } else {
          let questData = this.questionData;
          questData[
            "in_question_master_id"
          ] = evt.currentTarget.firstChild.getAttribute("data-que-id");
          this.getSurveyQuestWithDetailsByQuestionId(questData);
        }
      } else if (evt.srcElement.id === "expandShowMore") {
      } else if (evt.srcElement.id === "scoreIcon") {
        this.modalQid = evt.currentTarget.firstChild.getAttribute(
          "data-que-id"
        );
        this.modalQtypeId = this.surveyQuestionWithDetails[this.modalQid][
          Object.keys(this.surveyQuestionWithDetails[this.modalQid])[0]
        ];
        this.modalQtypeId = this.modalQtypeId["in_question_type_id"];
        this.modalSaveObj["id"] = evt.currentTarget.firstChild.getAttribute(
          "data-id"
        );
        this.modalSaveObj["qid"] = evt.currentTarget.firstChild.getAttribute(
          "data-qid"
        );
        this.modalSaveObj["in_question_master_id"] = this.modalQid;
        this.modalSaveObj[
          "controlName"
        ] = evt.currentTarget.firstChild.getAttribute("data-controlName");
        this.modalSaveObj[
          "className"
        ] = evt.currentTarget.firstChild.getAttribute("data-className");
        this.modalQindex = index;
        if (
          this.modalQtypeId == queTypeConfig.TYPE_LIST ||
          this.modalQtypeId == queTypeConfig.TYPE_SATISFACTION ||
          this.modalQtypeId == queTypeConfig.TYPE_STAR
        ) {
          this.ansArrayValues = [];
          if (this.surveyQuestionWithDetails[this.modalQid]["qval_6"]) {
            if (
              this.surveyQuestionWithDetails[this.modalQid]["qval_6"][
                "st_answer_score"
              ]
            ) {
              this.ansArrayValues = this.surveyQuestionWithDetails[
                this.modalQid
              ]["qval_6"]["st_answer_score"].split("\n");

              if (
                this.surveyQuestionWithDetails[this.modalQid]["qval_13"][
                  "st_answer_text"
                ]
              ) {
                this.scoreOther = this.surveyQuestionWithDetails[this.modalQid][
                  "qval_13"
                ]["st_answer_score"];
              }
            } else {
              // If answer score is not available in list question then clear other score also
              this.scoreOther = "";
            }
          } else if (
            this.surveyQuestionWithDetails[this.modalQid]["qval_38"]
              ? this.surveyQuestionWithDetails[this.modalQid]["qval_38"][
                  "st_answer_score"
                ]
              : 0
          ) {
            this.ansArrayValues = this.surveyQuestionWithDetails[this.modalQid][
              "qval_38"
            ]["st_answer_score"].split("\n");
          } else if (this.surveyQuestionWithDetails[this.modalQid]["qval_39"]) {
            let ansValues = this.surveyQuestionWithDetails[this.modalQid][
              "qval_39"
            ]["st_answer_text"].split("sep");
            console.log(ansValues);
            console.log(
              this.surveyQuestionWithDetails[this.modalQid]["qval_39"]
            );
            this.ansArrayValues = this.surveyQuestionWithDetails[this.modalQid][
              "qval_39"
            ]["st_answer_score"]
              ? this.surveyQuestionWithDetails[this.modalQid]["qval_39"][
                  "st_answer_score"
                ].split("\n")
              : [];
            let tmpVal = [];
            let tmpScore = [];
            if (ansValues.indexOf(":@") != -1) {
              tmpVal.push(":@");
              if (this.ansArrayValues[ansValues.indexOf(":@")]) {
                tmpScore.push(this.ansArrayValues[ansValues.indexOf(":@")]);
              }
            }
            if (ansValues.indexOf(":(") != -1) {
              tmpVal.push(":(");
              if (this.ansArrayValues[ansValues.indexOf(":(")]) {
                tmpScore.push(this.ansArrayValues[ansValues.indexOf(":(")]);
              }
            }
            if (ansValues.indexOf(":|") != -1) {
              tmpVal.push(":|");
              if (this.ansArrayValues[ansValues.indexOf(":|")]) {
                tmpScore.push(this.ansArrayValues[ansValues.indexOf(":|")]);
              }
            }
            if (ansValues.indexOf(":)") != -1) {
              tmpVal.push(":)");
              if (this.ansArrayValues[ansValues.indexOf(":)")]) {
                tmpScore.push(this.ansArrayValues[ansValues.indexOf(":)")]);
              }
            }
            if (ansValues.indexOf(":P") != -1) {
              tmpVal.push(":P");
              if (this.ansArrayValues[ansValues.indexOf(":P")]) {
                tmpScore.push(this.ansArrayValues[ansValues.indexOf(":P")]);
              }
            }
            this.ansArrayValues = tmpScore;
            this.smileyAnsVal = tmpVal;
            console.log(this.smileyAnsVal);
          } else {
            this.ansArrayValues = [];
          }
          document.body.appendChild(this.$refs.scoreModal.$el);
          this.$refs.scoreModal.show();
          //this.questionData.in_survey_question_answer_id = this.surveyQuestionWithDetails[
          //         this.modalQid
          //       ]["qval_6"]["in_survey_question_answer_id"]

          // await this.getSurveyAnswerWithScore(this.questionData).then(() => {
          //   if (this.surveyQuestionAnswerWithScore.st_answer_score)
          //     this.ansArrayValues = this.surveyQuestionAnswerWithScore.st_answer_score.split(
          //       "\n"
          //     );
          // else {
          //   this.ansArrayValues = [];
          // }
          // });
        } else if (
          this.modalQtypeId == queTypeConfig.TYPE_YES_NO ||
          this.modalQtypeId == queTypeConfig.TYPE_MULTIPLE_TEXT ||
          this.modalQtypeId == queTypeConfig.TYPE_TRUE_FALSE ||
          this.modalQtypeId == queTypeConfig.TYPE_OTHER ||
          this.modalQtypeId == queTypeConfig.TYPE_MULTIPLE_IMAGE
        ) {
          // if (
          //   this.surveyQuestionWithDetails[this.modalQid][13] &&
          //   this.surveyQuestionWithDetails[this.modalQid][13][
          //     "st_answer_text"
          //   ] == 1
          // ) {
          //   let scoreArray = {
          //     st_answer_text: "Other",
          //     st_answer_score: this.surveyQuestionWithDetails[
          //       this.modalQid
          //     ][13]["st_answer_score"]
          //   };
          //   this.$set(
          //     this.surveyQuestionWithDetails[this.modalQid]["score_data"],
          //     this.surveyQuestionWithDetails[this.modalQid][13][
          //       "in_survey_question_answer_id"
          //     ],
          //     scoreArray
          //   );
          //   console.log("kkk");
          //   console.log(this.surveyQuestionWithDetails[this.modalQid]);
          // }
            // this.$refs.scoreIcon._tooltip.show()
            this.multipleChoiceData = JSON.parse(
              JSON.stringify(
                this.surveyQuestionWithDetails[this.modalQid]["score_data"]
              )
            );
            document.body.appendChild(this.$refs.scoreModal.$el);
            this.$refs.scoreModal.show();
        } else {
          // this.questionData.in_survey_question_answer_id = this.surveyQuestionWithDetails[ this.modalQid]["qval_6"]["in_survey_question_answer_id"];
        }
      } else {
        // Set to no question selected whenever question updated
        this.currentQuestion = -4;
        var obj = [];
        if (index !== "") {
          // Set question if index present
          this.currentQuestion = index;
          // control Id
          obj["id"] = evt.currentTarget.firstChild.getAttribute("data-id");
          // Question Index id;=
          obj["qid"] = evt.currentTarget.firstChild.getAttribute("data-qid"); // this.qid
          // Db question Id
          obj[
            "in_question_master_id"
          ] = evt.currentTarget.firstChild.getAttribute("data-que-id");
          obj["controlName"] = evt.currentTarget.firstChild.getAttribute(
            "data-controlName"
          );
          obj["className"] = evt.currentTarget.firstChild.getAttribute(
            "data-className"
          );
          this.getQuestionData.in_question_master_id = evt.currentTarget.firstChild.getAttribute(
            "data-que-id"
          );
          this.getEditData(this.getQuestionData);
        }
        EventBus.$emit("questionTypeSelected", obj);
        if (evt.srcElement.id === "skipIcon") {
          this.updateSkipLogic();
        }
      }
    },
    setRequired(val, index) {
      this.$set(this.questionLists[index], "question_validation_details", []);
      // this.$set(this.questionLists[index]["question_validation_details"],0,{});
      this.questionLists[index]["question_validation_details"][0] = {};
      this.$set(
        this.questionLists[index]["question_validation_details"][0],
        "in_question_validation_id",
        1
      );
      this.questionLists[index]["question_validation_details"][0][
        "question_answer_details"
      ] = [];
      this.questionLists[index]["question_validation_details"][0][
        "question_answer_details"
      ][0] = {};
      this.$set(
        this.questionLists[index]["question_validation_details"][0][
          "question_answer_details"
        ][0],
        "st_answer_text",
        val
      );
    },
    collapseAll() {
      if (this.$refs.collapsible) {
        this.$refs.collapsible.map(c => (c.collapsed = true));
        this.startCollapsed = true;
        this.endCollapsed = true;
      }
    },
    expandAll() {
      if (this.$refs.collapsible) {
        this.$refs.collapsible.map(c => (c.collapsed = false));
        this.startCollapsed = false;
        this.endCollapsed = false;
      }
    },
    setExpandIcon() {
      if (this.$refs.collapsible) {
        var collapseLen = 0;
        this.$refs.collapsible.map(c => {
          if (c.collapsed === false) {
            collapseLen++;
          }
        });
        if (this.startCollapsed === false) collapseLen++;
        if (this.endCollapsed === false) collapseLen++;
        if (collapseLen > 0) {
          this.isExpand = true;
        } else this.isExpand = false;
      }
    },
    closeModal() {
      this.$refs.scoreModal.hide();
      this.errors.clear();
    },
    saveScore(e) {
      if (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED) {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.questionData.in_question_type_id = this.modalQtypeId;
            if (
              this.modalQtypeId == queTypeConfig.TYPE_LIST ||
              this.modalQtypeId == queTypeConfig.TYPE_SATISFACTION ||
              this.modalQtypeId == queTypeConfig.TYPE_STAR
            ) {
              this.questionData.in_survey_question_answer_id =
                this.modalQtypeId == queTypeConfig.TYPE_LIST
                  ? this.surveyQuestionWithDetails[this.modalQid]["qval_6"][
                      "in_survey_question_answer_id"
                    ]
                  : this.modalQtypeId == queTypeConfig.TYPE_STAR
                  ? this.surveyQuestionWithDetails[this.modalQid]["qval_38"][
                      "in_survey_question_answer_id"
                    ]
                  : this.surveyQuestionWithDetails[this.modalQid]["qval_39"][
                      "in_survey_question_answer_id"
                    ];
              this.questionData.st_answer_score = "";
              this.questionData.otherScore = {};
              for (var i = 0; i < this.ansArrayValues.length; i++) {
                if (this.surveyQuestionWithDetails[this.modalQid]["qval_39"]) {
                  let dbVals = this.surveyQuestionWithDetails[this.modalQid][
                    "qval_39"
                  ]["st_answer_text"].split("sep");
                  this.questionData.st_answer_score += this.ansArrayValues[
                    this.smileyAnsVal.indexOf(dbVals[i])
                  ];
                  if (i != this.ansArrayValues.length - 1)
                    this.questionData.st_answer_score += "\n";
                } else {
                  this.questionData.st_answer_score += this.ansArrayValues[i];
                  if (i != this.ansArrayValues.length - 1)
                    this.questionData.st_answer_score += "\n";
                }
              }
              if (this.surveyQuestionWithDetails[this.modalQid]["qval_13"]) {
                // Add score for allow other answers toggle button
                if(document.getElementById('13 others'))
                  document.getElementById('13 others').setAttribute('data-score-value', this.scoreOther);

                this.questionData.otherScore = {
                  in_survey_question_answer_id: this.surveyQuestionWithDetails[
                    this.modalQid
                  ]["qval_13"]["in_survey_question_answer_id"],
                  st_answer_score: this.scoreOther,
                  in_validation_id: 13
                };
              }

              this.$set(this.questionLists[this.modalQindex], "in_audit", 1);
              this.editSurveyAnswerWithScore(this.questionData);
            } else if (
              this.modalQtypeId == queTypeConfig.TYPE_YES_NO ||
              this.modalQtypeId == queTypeConfig.TYPE_MULTIPLE_TEXT ||
              this.modalQtypeId == queTypeConfig.TYPE_TRUE_FALSE ||
              this.modalQtypeId == queTypeConfig.TYPE_OTHER ||
              this.modalQtypeId == queTypeConfig.TYPE_MULTIPLE_IMAGE
            ) {
              this.questionData.score_data = this.multipleChoiceData;
              this.editSurveyAnswerWithMultipleScores(this.questionData).then(
                value => {
                  // Render question again if it is already selected for updating score values
                  if (this.currentQuestion == this.modalQindex) {
                    this.getQuestionData.in_question_master_id = this.modalQid;
                    this.getEditData(this.getQuestionData);
                    EventBus.$emit("questionTypeSelected", this.modalSaveObj);
                  }
                }
              );

              // If Allow More Than One Answer options enabled then we need to set audit flag as 0.
              if (this.surveyQuestionWithDetails[this.modalQid][20] && this.surveyQuestionWithDetails[this.modalQid][20]["st_answer_text"] == 1) {
                this.$set(this.questionLists[this.modalQindex], "in_audit", 0);
              } else {
                this.$set(this.questionLists[this.modalQindex], "in_audit", 1);
              }
            }
            this.$refs.scoreModal.hide();
          }
        });
      }
    },
    duplicateValues(index, lastIndex) {
      let y = this.ansArrayValues[index];
      for (let i = index + 1; i < lastIndex; i++) {
        this.$set(this.ansArrayValues, i, y);
      }
      if (this.surveyQuestionWithDetails[this.modalQid]["qval_13"]) {
        this.scoreOther = y;
      }
      this.errors.clear();
    },
    duplicateMultipleValues(index) {
      var y = this.multipleChoiceData[index]["st_answer_score"];
      let pos = Object.keys(this.multipleChoiceData).indexOf(index);
      var keys = Object.keys(this.multipleChoiceData);

      let counter;
      for (counter = 0; counter < keys.length; counter++) {
        if (counter <= pos) continue;
        this.$set(this.multipleChoiceData[keys[counter]], "st_answer_score", y);
      }
      if (
        this.multipleChoiceData[Object.keys(this.multipleChoiceData)[0]][
          "in_validation_id"
        ] == 13
      ) {
        this.$set(
          this.multipleChoiceData[Object.keys(this.multipleChoiceData)[0]],
          "st_answer_score",
          y
        );
      }
      this.errors.clear();
    },
    removeAudit() {
      if (this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED) {
        this.$wait.start("creating question");
        this.questionData.in_question_master_id = this.modalQid;
        this.removeAuditFromSurveyQuestion(this.questionData).then(value => {
          if (
            this.modalQtypeId == queTypeConfig.TYPE_LIST ||
            this.modalQtypeId == queTypeConfig.TYPE_SATISFACTION ||
            this.modalQtypeId == queTypeConfig.TYPE_STAR
          ) {
            // List Question
            if (this.surveyQuestionWithDetails[this.modalQid]["qval_6"] && this.surveyQuestionWithDetails[this.modalQid]["qval_6"]["st_answer_score"]) {
                this.surveyQuestionWithDetails[this.modalQid]["qval_6"]["st_answer_score"] = '';

                // List Question - Allow Other Answers
                if (this.surveyQuestionWithDetails[this.modalQid]["qval_13"]["st_answer_text"]) {
                  this.surveyQuestionWithDetails[this.modalQid]["score_data"] = {};
                  this.scoreOther = '';
                }
            } else if (
              this.surveyQuestionWithDetails[this.modalQid]["qval_38"]
                ? this.surveyQuestionWithDetails[this.modalQid]["qval_38"][
                    "st_answer_score"
                  ]
                : 0
            ) {
              // STAR RATING Question
              this.surveyQuestionWithDetails[this.modalQid]["qval_38"]["st_answer_score"] = '';
            } else if (this.surveyQuestionWithDetails[this.modalQid]["qval_39"]) {
              // SATISFACTION RATING Question
              this.surveyQuestionWithDetails[this.modalQid]["qval_39"]["st_answer_score"] = '';
            }
          } else if (
            this.modalQtypeId == queTypeConfig.TYPE_YES_NO ||
            this.modalQtypeId == queTypeConfig.TYPE_MULTIPLE_TEXT ||
            this.modalQtypeId == queTypeConfig.TYPE_TRUE_FALSE ||
            this.modalQtypeId == queTypeConfig.TYPE_OTHER ||
            this.modalQtypeId == queTypeConfig.TYPE_MULTIPLE_IMAGE
          ) {
            Object.keys(this.surveyQuestionWithDetails[this.modalQid]["score_data"]).forEach(key => {
              this.surveyQuestionWithDetails[this.modalQid]["score_data"][key]['st_answer_score'] = '';
            })
          }

          // Render question again if it is already selected for removing score values
          if (this.currentQuestion == this.modalQindex) {
            this.getQuestionData.in_question_master_id = this.modalQid;
            this.getEditData(this.getQuestionData);
            EventBus.$emit("questionTypeSelected", this.modalSaveObj); // To remove orange color
          } else {
            EventBus.$emit("emitGetQuestionAllData");
          }
          this.$wait.end("creating question");
        });
        this.$set(this.questionLists[this.modalQindex], "in_audit", 0);
        this.$refs.scoreModal.hide();
      }
    },
    // To avoid question from being dragged into other components and also to disable sort when skiplogic is added.
    checkMoveOfQuestion(event) {
      if (
        this.all.in_status !== constantCommonConfig.SURVEY_PUBLISHED &&
        event.to.className == "dragArea icon-edit" &&
        event.draggedContext.index > this.skipLogicEndQ - 1 &&
        event.draggedContext.futureIndex > this.skipLogicEndQ - 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    updateSkipLogic() {
      let val = {};
      val.skipLogic = true;
      val.qno = parseInt(this.currentQuestion);
      this.setIsSkipLogic(val);
    },
    updateSurveyDeleteFlag() {
      // If no questions are available then change flag to 1 => delete survey
      // If question is not available but start screen and end screen is also not active
      if(this.questionLists.length == 0 && this.startActivate == 0 && this.endActivate == 0)
        this.setSurvey_delete_flag([1, this.getQuestionData.sessionData]);
      else if(this.questionLists.length == 1)
        this.setSurvey_delete_flag([0, this.getQuestionData.sessionData]);
    },
    isNumberOnly(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if(/^[0-9]+$/.test(char)) return true; // Match with regex
        else e.preventDefault(); // If not match, don't add to input text
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/centerquestions.vue